import React, { useEffect, useState } from 'react';
import { serverApiUrl } from '../config/constants';
import httpClient from '../core/httpClient';
import ImageField from './ImageField';

const isProtectedChatAttachment = (image) => Boolean(image) && (image.startsWith('chat/user/') || image.startsWith('chat/admin/'));

const ResolvedChatImage = ({ image, messageId, selectedChatId, height = 5 }) => {
  const [resolvedUrl, setResolvedUrl] = useState(null);

  useEffect(() => {
    let isMounted = true;

    if (!image) {
      setResolvedUrl(null);
      return () => {
        isMounted = false;
      };
    }

    if (!isProtectedChatAttachment(image)) {
      setResolvedUrl(image);
      return () => {
        isMounted = false;
      };
    }

    const query = selectedChatId ? `?chat_id=${encodeURIComponent(selectedChatId)}` : '';
    const url = `${serverApiUrl}/admin/messages/${messageId}/image-url${query}`;

    setResolvedUrl(null);
    httpClient(url, { method: 'GET' })
      .then((res) => {
        if (isMounted) {
          setResolvedUrl(res.json.url);
        }
      })
      .catch(() => {
        if (isMounted) {
          setResolvedUrl(null);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [image, messageId, selectedChatId]);

  if (!resolvedUrl) {
    return null;
  }

  return <ImageField src={resolvedUrl} height={height} />;
};

export default ResolvedChatImage;
